import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PersonIcon from '@mui/icons-material/Person';
import LinkIcon from '@mui/icons-material/Link';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ReceiptIcon from '@mui/icons-material/Receipt';
import CalculateIcon from '@mui/icons-material/Calculate';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import ScheduleIcon from '@mui/icons-material/Schedule';
import CampaignIcon from '@mui/icons-material/Campaign';
import InsightsIcon from '@mui/icons-material/Insights';
import ForumIcon from '@mui/icons-material/Forum';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import HandshakeIcon from '@mui/icons-material/Handshake';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import LockIcon from '@mui/icons-material/Lock';
import HistoryIcon from '@mui/icons-material/History';
import LockClockIcon from '@mui/icons-material/LockClock';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import MenuBookIcon from '@mui/icons-material/MenuBook';

// ==========================================
// 1. CẤU HÌNH MÀU SẮC DÙNG CHUNG
// ==========================================
export const WIDGET_COLORS = [
  { value: '#ffffff', label: 'Trắng Tinh Giản', isGradient: false, textColor: '#111827' },
  // Nhóm màu đậm: Dùng chữ Trắng
  { value: '#007aff', label: 'Xanh dương (Chỉ tô màu Icon)', isGradient: false, textColor: '#ffffff' },
  { value: '#34c759', label: 'Xanh lá (Chỉ tô màu Icon)', isGradient: false, textColor: '#ffffff' },
  { value: '#ff3b30', label: 'Đỏ (Chỉ tô màu Icon)', isGradient: false, textColor: '#ffffff' },
  
  // Nhóm nền Pastel (Sáng): Dùng chữ màu đậm tương đồng để tạo độ tương phản cao
  { 
    value: 'linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)', 
    label: 'Nền Xanh Dương', 
    isGradient: true, 
    textColor: '#1e3a8a' // Xanh navy đậm
  },
  { 
    value: 'linear-gradient(135deg, #d4fc79 0%, #96e6a1 100%)', 
    label: 'Nền Xanh Lá', 
    isGradient: true, 
    textColor: '#14532d' // Xanh rêu đậm
  },     
  { 
    value: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)', 
    label: 'Nền Cam', 
    isGradient: true, 
    textColor: '#7c2d12' // Nâu cam đậm
  },         
  { 
    value: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)', 
    label: 'Nền Đỏ San Hô', 
    isGradient: true, 
    textColor: '#831843' // Đỏ rượu vang/Hồng đậm
  },   
  { 
    value: 'linear-gradient(135deg, #e0c3fc 0%, #8ec5fc 100%)', 
    label: 'Nền Tím', 
    isGradient: true, 
    textColor: '#312e81' // Tím than
  },         
];

// ==========================================
// 2. CẤU HÌNH ICON DÙNG CHUNG (CHO SHORTCUT)
// ==========================================
export const SHORTCUT_ICONS = [
  { value: 'link', label: 'Mặc định (Link)', icon: LinkIcon },
  { value: 'add', label: 'Dấu cộng (Thêm mới)', icon: AddCircleOutlineIcon },
  { value: 'assignment', label: 'Tài liệu (Văn bản)', icon: AssignmentIcon },
  { value: 'person', label: 'Con người (Khách hàng)', icon: PersonIcon },
  { value: 'voucher', label: 'Thẻ ưu đãi (Voucher)', icon: LocalOfferIcon },
  { value: 'list', label: 'Danh sách (List)', icon: FormatListBulletedIcon },
  { value: 'report', label: 'Báo cáo (Report)', icon: AssessmentIcon },
  { value: 'receipt', label: 'Chứng từ / Hóa đơn', icon: ReceiptIcon },
  { value: 'calculate', label: 'Tính toán / Máy tính', icon: CalculateIcon },
  // Bộ icon cho bán hàng & marketing. Giá trị KHÔNG có trong danh sách này sẽ âm thầm rơi về
  // 'link' (SHORTCUT_ICONS[0]) — cả dashboard hiện một icon giống hệt nhau mà không báo lỗi gì.
  { value: 'person_add', label: 'Thêm người (Lead mới)', icon: PersonAddAlt1Icon },
  { value: 'support_agent', label: 'Tư vấn / Chăm sóc', icon: SupportAgentIcon },
  { value: 'how_to_reg', label: 'Đã chuyển đổi', icon: HowToRegIcon },
  { value: 'schedule', label: 'Đồng hồ / Quá hạn', icon: ScheduleIcon },
  { value: 'campaign', label: 'Chiến dịch / Loa', icon: CampaignIcon },
  { value: 'insights', label: 'Biểu đồ xu hướng', icon: InsightsIcon },
  { value: 'forum', label: 'Tin nhắn / Hội thoại', icon: ForumIcon },
  { value: 'view_kanban', label: 'Bảng Kanban', icon: ViewKanbanIcon },
  { value: 'handshake', label: 'Cơ hội / Chốt deal', icon: HandshakeIcon },
  // Bộ icon cho module Hiệu suất (chốt kỳ, cảnh báo, thư viện chỉ tiêu, nhật ký tính lại).
  { value: 'notifications_active', label: 'Cảnh báo / Nhắc việc', icon: NotificationsActiveIcon },
  { value: 'lock', label: 'Khoá / Đã chốt', icon: LockIcon },
  { value: 'history', label: 'Lịch sử / Tính lại', icon: HistoryIcon },
  { value: 'lock_clock', label: 'Chốt kỳ theo thời gian', icon: LockClockIcon },
  { value: 'library_books', label: 'Thư viện chỉ tiêu', icon: LibraryBooksIcon },
  { value: 'fact_check', label: 'Nhật ký / Đối chiếu', icon: FactCheckIcon },
  { value: 'menu_book', label: 'Hướng dẫn sử dụng', icon: MenuBookIcon },
];